(() => {
  const closeMenus = (event) => document.querySelectorAll('[data-gn-menu][open]').forEach(menu => {
    if (event.type === 'keydown' && event.key === 'Escape') { menu.open = false; menu.querySelector('summary')?.focus(); }
    if (event.type === 'click' && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
})();
